/**
 * Fix for featured-product thumbnail vertical scrolling
 * Only applies to .featured-product sections
 */
(function() {
  // Only run after DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedProductFix);
  } else {
    initFeaturedProductFix();
  }

  function initFeaturedProductFix() {
    // Only target media-gallery inside featured-product sections
    const featuredProductGalleries = document.querySelectorAll('.featured-product media-gallery');
    
    if (!featuredProductGalleries.length) return;
    
    featuredProductGalleries.forEach((gallery) => {
      // Wait for the gallery to initialize
      const checkInterval = setInterval(() => {
        if (gallery.sliderInstance && gallery.thumbsInstance) {
          clearInterval(checkInterval);
          fixThumbnailScrolling(gallery);
        }
      }, 100);
      
      setTimeout(() => clearInterval(checkInterval), 5000);
    });
  }

  function fixThumbnailScrolling(gallery) {
    const mainSlider = gallery.sliderInstance.slider;
    const thumbsSlider = gallery.thumbsInstance.slider;
    
    if (!mainSlider || !thumbsSlider) return;
    
    // CRITICAL: Remove ALL existing event listeners
    mainSlider.off('realIndexChange');
    mainSlider.off('slideChange');
    
    // Function to update thumbnail position
    function updateThumbnailPosition(realIndex) {
      if (window.innerWidth >= 768) {
        const thumbSlides = thumbsSlider.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
        
        if (thumbSlides && thumbSlides[realIndex]) {
          const slideHeight = thumbSlides[realIndex].offsetHeight;
          const gap = parseInt(gallery.dataset.mediaItemGap) || 0;
          const totalSlideHeight = slideHeight + gap;
          
          // Calculate Y position
          const yPosition = -((realIndex - 1) * totalSlideHeight);
          const finalYPosition = Math.min(0, yPosition);
          
          // Apply transform with smooth transition
          const thumbWrapper = thumbsSlider.wrapperEl;
          if (thumbWrapper) {
            thumbWrapper.style.transform = `translate3d(0px, ${finalYPosition}px, 0px)`;
            thumbWrapper.style.transition = 'transform 0.3s ease';
          }
          
          // Update active class
          thumbsSlider.slides.forEach(slide => slide.classList.remove('swiper-slide-thumb-active'));
          thumbSlides[realIndex]?.classList.add('swiper-slide-thumb-active');
        }
      } else {
        thumbsSlider.slideTo(realIndex);
      }
    }
    
    // Listen to realIndexChange for vertical scrolling
    mainSlider.on('realIndexChange', (swiper) => {
      updateThumbnailPosition(swiper.realIndex);
    });
    
    // Listen to slideChangeTransitionEnd to ensure position is correct after loop
    mainSlider.on('slideChangeTransitionEnd', (swiper) => {
      updateThumbnailPosition(swiper.realIndex);
    });
    
    // Handle the media playing from the original script
    mainSlider.on('realIndexChange', (swiper) => {
      const {slides, activeIndex} = swiper;
      if (slides[activeIndex]) {
        const deferredMedia = slides[activeIndex].querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
        
        const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
        if (mainSlider.allowTouchMove !== !isModelMediaType) {
          mainSlider.allowTouchMove = !isModelMediaType;
        }
      }
    });
  }
})();